module.exports = __webpack_public_path__ + "img/1.201c0b79.png";